'use strict';
require('../../../modules/es.array.find-index');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'findIndex');
